import { render, staticRenderFns } from "./myBets4dPanel.vue?vue&type=template&id=aca373b0&lang=pug&"
import script from "./myBets4dPanel.vue?vue&type=script&lang=js&"
export * from "./myBets4dPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports